import React from 'react'

const Quran = () => {
  return (
      <div data-aos="zoom-in-up" data-aos-duration="1000" className='w-full px-5 py-6 mx-auto space-y-5 text-xs text-center lg:py-12 lg:text-sm lg:w-2/3'>
        <div className="italic">Dan di antara tanda-tanda (kebesaran)-Nya ialah Dia menciptakan pasangan-pasangan untukmu dari jenismu sendiri, agar kamu cenderung dan merasa tenteram kepadanya, dan Dia menjadikan di antaramu rasa kasih dan sayang. Sungguh, pada yang demikian itu benar-benar terdapat tanda-tanda (kebesaran Allah) bagi kaum yang berpikir.</div>
        <div>QS. Ar Rum:21</div>
      </div>
  )
}

export default Quran